"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement("svg", {
    style: customStyles,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className ? className + ' icon icon-log-out' : 'icon icon-log-out'
  }, _react2.default.createElement("g", {
    id: "create-new-project_new-layout"
  }, _react2.default.createElement("g", {
    id: "_x31_11.2-Menu_x5F_issuer_x5F_and_x5F_investor",
    transform: "translate(-1064.000000, -129.000000)"
  }, _react2.default.createElement("g", {
    id: "drop-down-menu",
    transform: "translate(1048.000000, 67.000000)"
  }, _react2.default.createElement("g", {
    id: "sign-out-alt-solid",
    transform: "translate(16.000000, 64.000000)"
  }, _react2.default.createElement("path", {
    fill: "currentColor",
    d: "M15.8,6.5l-5.3,5.2c-0.5,0.5-1.3,0.1-1.3-0.5v-3H4.8c-0.4,0-0.8-0.3-0.8-0.7v-3 c0-0.4,0.3-0.7,0.8-0.7h4.3v-3c0-0.7,0.8-1,1.3-0.5l5.3,5.2C16.1,5.8,16.1,6.2,15.8,6.5z M6.1,11.6v-1.2c0-0.2-0.2-0.4-0.4-0.4 H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.5-1,1-1h2.7c0.2,0,0.4-0.2,0.4-0.4V0.4C6.1,0.2,5.9,0,5.7,0H3C1.4,0,0,1.3,0,3v6c0,1.7,1.4,3,3,3 h2.7C5.9,12,6.1,11.8,6.1,11.6z"
  }))))));
};